import React from 'react';

import { PressedKeysContext } from '@neptune/shared/keyboard-domain';

type UseIsKeyBeingPressedParams = {
  key: string;
  enabled?: boolean;
};

export const useIsKeyBeingPressed = ({
  key,
  enabled = true,
}: UseIsKeyBeingPressedParams): boolean => {
  const context = React.useContext(PressedKeysContext);

  if (context === null) {
    throw new Error('useIsKeyBeingPressed must be used within PressedKeysProvider');
  }

  const [isKeyBeingPressed, setIsKeyBeingPressed] = React.useState(
    () => enabled && context.isKeyPressed(key),
  );

  React.useEffect(() => {
    if (!enabled) {
      setIsKeyBeingPressed(false);
      return;
    }

    setIsKeyBeingPressed(context.isKeyPressed(key));
    return context.subscribeToKey(key, setIsKeyBeingPressed);
  }, [context, enabled, key]);

  return isKeyBeingPressed;
};
